<template>
    <ProductComparison :isPublic="true"></ProductComparison>
</template>

<script>
    import ProductComparison from "../../components/parametric-search/ProductComparison";

    export default {
        name: "comparison-page",
        components: {
            ProductComparison,
        }
    };
</script>